import { render, staticRenderFns } from "./UserSetting.vue?vue&type=template&id=0cab8e52&scoped=true"
import script from "./UserSetting.vue?vue&type=script&lang=js"
export * from "./UserSetting.vue?vue&type=script&lang=js"
import style0 from "./UserSetting.vue?vue&type=style&index=0&id=0cab8e52&prod&lang=scss"
import style1 from "./UserSetting.vue?vue&type=style&index=1&id=0cab8e52&prod&lang=scss&scoped=true"
import style2 from "./UserSetting.vue?vue&type=style&index=2&id=0cab8e52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cab8e52",
  null
  
)

export default component.exports